export default {
	"updatePolicy.title": "Versicherung anpassen",
	"updatePolicy.submit.label": "Versicherung anpassen",
	"updatePolicy.success.title": "Versicherung angepasst",
	"updatePolicy.success.text":
		"Ihre Versicherung wurde angepasst. Sie erhalten eine Bestätigung als E-Mail. Vielen Dank für Ihr Vertrauen.",
} as const;
